<template>
    <div>
        Commit: {{ commitHash }}<br>
        Version: {{ version }}
    </div>
</template>

<script>
export default {
    data() {
        return {
            commitHash: process.env.VUE_APP_GIT_COMMIT_HASH,
            version: process.env.VUE_APP_VERSION
        }
    }
}
</script>
